import React, { useContext } from "react";
import { NotificationContext } from "../NotificationContext";

const ToastNotification = () => {
  const { notifications, removeNotification } = useContext(NotificationContext);

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "400px",
      }}
    >
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`alert alert-${notification.type === "error" ? "danger" : notification.type}`}
          role="alert"
          style={{
            margin: 0,
            animation: "slideIn 0.3s ease-in",
            borderRadius: "0.625rem",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>{notification.message}</span>
            <button
              type="button"
              className="btn-close"
              onClick={() => removeNotification(notification.id)}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastNotification;
